import { ATT_STATUS } from "@/lib/constants";

export function StatusBadge({ status, testid }) {
  const s = ATT_STATUS[status] || { label: status, cls: "bg-slate-100 text-slate-700 border-slate-200" };
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium ${s.cls}`}
    >
      {s.label}
    </span>
  );
}
